import { Module } from "./Module";
import { UserPermissionRank } from './UserPermissionRank';
import { UserPermissionType } from "./UserPermissionType";


export default interface ModulesJson {
   /**
    * Angezeigter Titel des Moduls
    */
   title: string;

   /**
    * Name des component, welches angezeigt werden soll
    */
   linkedComponent: Module | string;

   /**
    * Mindestens erforderliche Berechtigung um das Modul zu nutzen
    */
   permissionRank: UserPermissionRank;

   /**
    * Mindestens erforderliche Berechtigung um das Modul zu nutzen
    */
   userPermission: UserPermissionType | null;

   /**
    * Gibt an ob das Modul deaktiviert ist
    */
   isDisabled: boolean;

   /**
    * Gibt an ob das Modul angezeigt wird
    */
   isDisplayed: boolean;
}

export function checkModuleIsActivated(allModules: ModulesJson[], linkedComponent: string) {
   var module = allModules.find((i: any) => i.linkedComponent == linkedComponent);

   if (module) {
      if (!module.isDisabled) {
         return true;
      }
   }

   return false;
};

export const allModules: ModulesJson[] = [
   {
      title: "Übersicht",
      linkedComponent: Module.Overview,
      permissionRank: 2,
      userPermission: null,
      isDisabled: false,
      isDisplayed: false
   },
   {
      title: "Veranstaltungen",
      linkedComponent: Module.Events,
      permissionRank: 2,
      userPermission: UserPermissionType.moduleEvents,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Geburtstage",
      linkedComponent: Module.Birthdays,
      permissionRank: 1,
      userPermission: UserPermissionType.moduleBirthdays,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Ferienbetreuung",
      linkedComponent: Module.Holidays,
      permissionRank: 2,
      userPermission: UserPermissionType.moduleHolidays,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Kurse",
      linkedComponent: Module.Workshops,
      permissionRank: 2,
      userPermission: UserPermissionType.moduleWorkshops,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Gruppen",
      linkedComponent: Module.Groups,
      permissionRank: 2,
      userPermission: UserPermissionType.moduleGroups,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Mitglieder",
      linkedComponent: Module.Members,
      permissionRank: 2,
      userPermission: UserPermissionType.moduleMembers,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Mailings",
      linkedComponent: Module.Mailings,
      permissionRank: 2,
      userPermission: UserPermissionType.moduleMailings,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Personen",
      linkedComponent: Module.Clients,
      permissionRank: 2,
      userPermission: UserPermissionType.moduleClients,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Accounts",
      linkedComponent: Module.Accounts,
      permissionRank: 2,
      userPermission: UserPermissionType.moduleAccounts,
      isDisabled: false,
      isDisplayed: false
   },
   {
      title: "Zahlungsverkehr",
      linkedComponent: Module.Payments,
      permissionRank: 2,
      userPermission: UserPermissionType.modulePayments,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Statistiken",
      linkedComponent: Module.Statistics,
      permissionRank: 2,
      userPermission: UserPermissionType.moduleStatistics,
      isDisabled: false,
      isDisplayed: true
   },
   {
      title: "Einstellungen",
      linkedComponent: Module.Settings,
      permissionRank: 1,
      userPermission: null,
      isDisabled: false,
      isDisplayed: true
   }
];